import request from '@/utils/request'


// 查询用户种子余额列表
export function listSeed(query) {
  return request({
    url: '/user/seed/list',
    method: 'get',
    params: query
  })
}

// 查询用户种子余额分页
export function pageSeed(query) {
  return request({
    url: '/user/seed/page',
    method: 'get',
    params: query
  })
}

// 查询用户种子余额详细
export function getSeed(data) {
  return request({
    url: '/user/seed/detail',
    method: 'get',
    params: data
  })
}

// 新增用户种子余额
export function addSeed(data) {
  return request({
    url: '/user/seed/add',
    method: 'post',
    data: data
  })
}

// 修改用户种子余额
export function updateSeed(data) {
  return request({
    url: '/user/seed/edit',
    method: 'post',
    data: data
  })
}

// 删除用户种子余额
export function delSeed(data) {
  return request({
    url: '/user/seed/delete',
    method: 'post',
    data: data
  })
}
